<!--Tarjeta de evento de usuario
    Por cada evento al que vaya asistir un usuario se mostrará este componente la misma cantidad 
    de evento que haya adquirido el usuario-->
<!--FUNCIONALIDAD AÚN SIN USAR-->
<template>
  <v-card hover class="fill-height">
    <v-container fluid class="fill-height">
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-row justify="center" align="center">
            <v-col cols="12" sm="3" class="py-0">
              <v-row justify="center">
                <v-avatar size="100">
                  <img :src="event.eventImage" />
                </v-avatar>
              </v-row>
            </v-col>
            <v-col cols="12" sm="9">
              <v-row>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <h2 class="title font-weight-bold" style="display:inline;">Evento:</h2>
                      {{event.name}}
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <h2 class="title font-weight-bold" style="display:inline;">Inicio:</h2>
                      {{ formatDate(event.startDate) }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6" v-if="beforeDate">
                  <v-row class="my-2" justify="center">
                    <v-btn small class="accent">Volver a comprar</v-btn>
                  </v-row>
                  <v-row class="my-2" justify="center">
                    <v-btn small class="accent" :to="`/eventos/${event.id}`">Ver detalles</v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row justify="center" align="center" class="text-center">
            <v-col cols="6" class="pb-0">
              <h3 class="subtitle-2 font-weight-bold" style="display:inline;">Fecha de compra:</h3>
              {{ formatDate(event.order.createdAt) }}
            </v-col>
            <v-col cols="6" class="pb-0">
              <h3 class="subtitle-2 font-weight-bold" style="display:inline;">Comprador:</h3>
              {{ `${event.order.paymentInformation.name} ${event.order.paymentInformation.lastName}` }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true }
  },
  data() {
    return {
      overlay: false
    };
  },
  methods: {
    details() {
      this.$router.push({
        name: "event-detail",
        params: { id: this.event.id }
      });
    },
    formatDate(date) {
      let dateArr = date.split('-')
      return `${dateArr[2]}-${dateArr[1]}-${dateArr[0]}`;
    },
  },
  computed: {
    beforeDate(){
      let today = new Date();
      let date = this.event.startDate.split('-')
      let eventDate = new Date(date[0], Number(date[1])-1, date[2])
      if(eventDate>=today)
        return true
      else
        return false
    }
  }
};
</script>
<style scoped>
</style>
